import React from 'react';
import { Link } from 'react-router-dom';
interface FooterLink {
  label: string;
  to?: string;
  href?: string;
}
interface FooterColumn {
  title: string;
  links: FooterLink[];
}
const columns: FooterColumn[] = [{
  title: 'Solutions',
  links: [{
    label: 'For Brands',
    to: '/for-brands'
  }, {
    label: 'For Marketing Agencies',
    to: '/for-marketing-agencies'
  }, {
    label: 'For Talent Agencies',
    to: '/for-talent'
  }]
}, {
  title: 'Company',
  links: [{
    label: 'Home',
    to: '/'
  }, {
    label: 'Case Studies',
    to: '/case-studies'
  }, {
    label: 'Pricing',
    to: '/pricing'
  }, {
    label: 'Login',
    href: 'https://app.zanoplatform.com/sign-in'
  }]
}, {
  title: 'Legal',
  links: [{
    label: 'Privacy Policy',
    to: '/privacy-policy'
  }, {
    label: 'Terms of Service',
    to: '/terms-of-service'
  }, {
    label: 'Cookie Policy',
    to: '/cookie-policy'
  }]
}, {
  title: 'Contact',
  links: [{
    label: 'support@zanoplatform.com',
    href: 'mailto:support@zanoplatform.com'
  }]
}];
const linkClass = 'text-sm text-gray-500 hover:text-zano-pink transition-colors';
export const Footer = () => {
  return <footer className="bg-white border-t border-gray-100 pt-14 pb-10" data-id="element-421" data-mp="817b9zwxjeqw">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-422" data-mp="32w2lsidfaa9">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 gap-y-10" data-id="element-423" data-mp="hstrybs1e611">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1" data-id="element-424" data-mp="ctqmiq859xsj">
            <Link to="/" className="inline-flex items-center" data-id="element-425" data-mp="cu8ugk4660ga">
              <img src="https://cdn.magicpatterns.com/uploads/gbY7Dn8gGgHtYDAdDbncPd/zano_logo_full1.png" alt="Zano" className="h-6 w-auto" data-id="element-426" data-mp="qt051wjtp3zo" />
            </Link>
            <p className="mt-4 text-sm text-gray-500 leading-relaxed max-w-xs" data-id="element-427" data-mp="twfp9wj4m1th">
              The discovery layer for represented influencers.
            </p>
          </div>

          {/* Link columns */}
          {columns.map(col => <nav key={col.title} aria-label={col.title} data-id="element-428" data-mp="13rg0iugnny0i">
              <h3 className="text-xs font-semibold uppercase tracking-wider text-zano-charcoal mb-4" data-id="element-429" data-mp="18ksor3hfa2sq">
                {col.title}
              </h3>
              <ul className="space-y-3" data-id="element-430" data-mp="1hkp6sm9b43et">
                {col.links.map(link => <li key={link.label} data-id="element-431" data-mp="1hmiem4vnotoe">
                    {link.to ? <Link to={link.to} className={linkClass} data-id="element-432" data-mp="1mkbiusdefdm1">
                        {link.label}
                      </Link> : <a href={link.href} target={link.href?.startsWith('http') ? '_blank' : undefined} rel={link.href?.startsWith('http') ? 'noopener noreferrer' : undefined} className={`${linkClass} break-words`} data-id="element-433" data-mp="3obol19nzf7ee">
                        {link.label}
                      </a>}
                  </li>)}
              </ul>
            </nav>)}
        </div>

        <div className="mt-12 pt-8 border-t border-gray-100 text-sm text-gray-400" data-id="element-434" data-mp="2pcebnklzxbpd">
          © {new Date().getFullYear()} Zano. All rights reserved.
        </div>
      </div>
    </footer>;
};